import { render, staticRenderFns } from "./SortSelect.vue?vue&type=template&id=2fd8c4d4&scoped=true"
import script from "./SortSelect.ts?vue&type=script&lang=ts&external"
export * from "./SortSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./SortSelect.vue?vue&type=style&index=0&id=2fd8c4d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd8c4d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fd8c4d4')) {
      api.createRecord('2fd8c4d4', component.options)
    } else {
      api.reload('2fd8c4d4', component.options)
    }
    module.hot.accept("./SortSelect.vue?vue&type=template&id=2fd8c4d4&scoped=true", function () {
      api.rerender('2fd8c4d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/components/list/SortSelect/SortSelect.vue"
export default component.exports